export default new URL("../images/slide1.jpg", import.meta.url).href;